import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { twJoin } from "tailwind-merge";
// import { twMerge } from "tailwind-merge";

type TooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  className?: string | undefined;
  asChild?: boolean;
};

export function Tooltip({
  children,
  content,
  asChild,
  className,
}: TooltipProps) {
  return (
    <TooltipPrimitive.Root delayDuration={undefined}>
      <TooltipPrimitive.Trigger asChild={asChild} className={className}>
        {children}
      </TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          className={twJoin(
            "data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade",
            "data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade",
            "first-letter:data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade",
            "select-none leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity]",
            "z-30 max-w-[25ch] rounded border-stone-800/20 bg-stone-600 p-2 text-sm text-white"
          )}
          sideOffset={5}
          alignOffset={10}
        >
          {content}
          <TooltipPrimitive.Arrow className="fill-stone-600 drop-shadow" />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
